import React from "react";
import {Container} from "../../react-components/shared/SharedComponents";
import {FarmyColumnSet, FarmyColumn} from "./components/FarmyColumns";
import currentTheme from "../../react-themes/theme";

const theme = currentTheme();

export const MainContent = (props) => {
  const {children, className = "", style} = props;

  return <Container>
    <FarmyColumn
      width={"100%"}
      className={`farmy-main-content ${className}`}
      style={{...style}}
    >
      {children}
    </FarmyColumn>
  </Container>;
};

export const Sidebar = (props) => {
  const {children, className = "", style} = props;

  return <FarmyColumn
    className={`farmy-sidebar flex-shrink-0 ${className}`}
    style={{
      flexBasis: 0,
      ...style
    }}
  >
    {children}
  </FarmyColumn>;
};

export const PageContentWrapper = (props) => {
  const {children, className = "", style} = props;

  return <FarmyColumnSet
    className={`
      page-content-wrapper 
      flex  
      justify-content-center 
      margin-bottom-20 
      ${className}
    `}
    style={{
      gap: theme.columns.gaps.sm,
      ...style
    }}
  >
    {children}
  </FarmyColumnSet>;
};
